export enum PostHogFeatureFlags {
  SIMPLIFIED_PHISHING_PLANNING_SCREEN = 'simplified-phishing-planning-screen',
  EXPORT_TO_LMS = 'lms-export',
  ENTRA_ID_FIELD_MAPPING = 'entra-id-field-mapping',
  SIMPLIFIED_SC_SURVEY_PLANNER = 'simplified-sc-survey-planner',
  USER_DOMAIN_VERIFICATION = 'user-domain-verification',
  PHISHING_SIMULATION_FOLLOW_UP = 'phishing-simulation-follow-up',
  TRAINING_VARIABLES = 'training-variables',
  FREE_TRIAL_PLATFORM_RESTRICTIONS = 'free-trial-platform-restrictions',
  AI_PHISHING_EMAIL_EDITING = 'ai-phishing-email-editing',
  OSINT_TRANSPARENCY = 'osint-transparency',
  ADMIN_UI_NORWEGIAN = 'admin-ui-norwegian',
  MANAGER_USER_REFERENCE = 'manager-user-reference',
  HONEYPOT_FALSE_POSITIVE_DETECTION = 'honeypot-false-positive-detection',
  AUTO_PHISHING_SCHEDULER = 'auto-phishing-scheduler',
  CUSTOM_ROLES = 'custom-roles',
  PHISHING_INTRO_PAGE = 'phishing-intro-page',
  PHISHING_TEMPLATE_LEVEL_VIEW = 'phishing-template-level-view',
  CONTENT_PAGE_BROWSE_VIEW = 'content-page-browse-view',
  CONTENT_PAGE_BROWSE_DEFAULT = 'content-page-browse-default',
  SSO_ORPHAN_KEYCLOAK_CLEANUP = 'sso-orphan-keycloak-cleanup',
  SMART_LANGUAGE_TARGETING = 'smart-language-targeting',
  HIDE_AWARENESS_TRAINING = 'hide-awareness-training',
}

export enum PostHogFeatureVariant {}

export enum PostHogCustomEvent {
  USER_CLICKED_CONTENT_HIGHLIGHTED_CONTENT = 'user_clicked_content_highlighted_content',
  COURSE_COMPLETED = 'course_completed',
  COURSE_COMPLETED_REQUEST_SUCCESS = 'course_completed_request_success',
  USER_LOGGED_IN = 'user_logged_in',
  ACCESSIBILITY_ICON_CLICKED = 'accessibility_icon_clicked',

  // I have no clue what these are for and neither does the PO, so I'm marking them as deprecated just in case.
  /** @deprecated */ COURSE_COMMIT = 'course_commit ',
}

export enum PostHogEvent {
  PAGE_VIEW = '$pageview',
}
